'use client'

import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { createInterval } from './utils'
import styles from './loadingScreen.module.scss'

interface LoaderScreenProps {
  screens: Array<{ icon: string; alt: string; text: string }>
  duration?: number
  regNo?: string
  onComplete?: () => void
  isMobile: boolean
  isBottomFloater: boolean
  showLoadingScreen: boolean
}

const LoaderScreen: React.FC<LoaderScreenProps> = ({
  screens,
  duration,
  regNo,
  onComplete,
  isMobile,
  isBottomFloater,
  showLoadingScreen,
}) => {
  const [currentScreenIndex, setCurrentScreenIndex] = useState<number>(0)
  const onCompleteRef = useRef(onComplete)
  onCompleteRef.current = onComplete

  useEffect(() => {
    if (showLoadingScreen && !isMobile) {
      document.documentElement.style.overflowY = 'hidden'
    }
  }, [])

  useEffect(() => {
    if (duration) {
      const cleanup = createInterval(
        setCurrentScreenIndex,
        duration,
        () => onCompleteRef.current?.(),
        screens.length
      )
      return cleanup
    }
  }, [screens.length, duration])

  const currentScreen = screens[currentScreenIndex]

  return (
    <>
      {!isMobile && !isBottomFloater && <div className={styles.desktopLoaderOverlay} />}

      <div className={isMobile ? styles.mobileLoaderScreen : styles.desktopLoaderScreen}>
        <div className={styles.gifContainer}>
          <Image src={currentScreen.icon} alt={currentScreen.alt} width={337} height={90} loading="lazy" />
          {regNo && <div className={styles.regNo}>{regNo}</div>}
        </div>
        <p className={styles.loaderText}>{currentScreen.text}</p>
      </div>
    </>
  )
}

export default LoaderScreen
